// extracted by mini-css-extract-plugin
export default {"container":"yK-z","dimension":"zK-z","dimensionLabels":"AK-z"};